<template>
  <div class="page">
    <!-- 搜索栏头部 -->
    <div class="header-bar">
      <van-icon class="van-nav-bar__arrow" name="arrow-left" color="#fff" @click="$router.go(-1)" />
      <van-search class="header-search" v-model="params.queryName" placeholder="请输入子账号名称搜索" background="#117281"
        @search="viewItemList('01')" />
      <span class="header-right" @click="addressSubSearch">搜索</span>
    </div>
    <!-- 内容 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false">
        <div class="sub-card" v-for="(subAddress, index) in subAddressList" :key="index"
          @click="receivingAddressSelect(subAddress)">
          <div class="sub-info">
            <p>联系人：{{ subAddress.contactPerson }}</p>
            <p>联系电话：{{ subAddress.contactMobile }}</p>
          </div>
          <p class="sub-info">
            地址：{{ subAddress.provinceName }}{{ subAddress.cityName }}{{ subAddress.countyName }}{{
                subAddress.detailAddress
            }}
          </p>
          <van-divider />
          <p class="sub-name">{{ subAddress.clientName }}</p>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import centerApi from '@/api/center'
import { mapState } from 'vuex'
export default {
  components: {},
  data () {
    return {
      params: {
        page: 1,
        pageSize: 10,
        queryName: ''
      },
      subAddressList: [],
      loading: false,
      finished: false,
      refreshing: false,
      selectCouponId: 0,
      mode: ''
    }
  },
  created () {
    this.selectCouponId = this.$route.params.couponId || 0
    this.mode = this.$route.params.mode || ''
    if (this.userRole === '03') {
      this.$toast('没有查看收货地址的权限')
    } else {
      this.refreshing = true
      this.onRefresh()
    }
  },
  computed: {
    ...mapState({
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    })
  },
  methods: {
    // 到底加载
    onLoad () {
      if (this.refreshing) {
        this.refreshing = false
        this.params.page = 1
        this.subAddressList = []
      }
      const params = {
        page: this.params.page,
        pageSize: this.params.pageSize,
        queryName: this.params.queryName,
        queryPerson: '',
        queryAddress: ''
      }
      centerApi.getAddressSubList(params).then(res => {
        if (res.data.resultCode === '0') {
          const { subAddressList } = res.data.resultData
          this.subAddressList = this.subAddressList.concat(subAddressList)
          this.loading = false
          this.params.page++
          if (!subAddressList.length) {
            this.finished = true
          }
        }
      })
    },
    // 下拉刷新
    onRefresh () {
      // 清空列表数据
      this.finished = false
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    // 名称搜索
    addressSubSearch () {
      this.refreshing = true
      this.onRefresh()
    },
    // 选取子账号地址
    receivingAddressSelect (address) {
      if (this.mode === 'order') {
        this.$router.push({
          name: 'orderCreate',
          params: {
            type: 'sub',
            newAddressId: String(address.addressId),
            contactPerson: address.contactPerson,
            contactMobile: address.contactMobile,
            detailAddress: address.provinceName + address.cityName + address.countyName + address.detailAddress
          }
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.header-bar {
  display: flex;
  background-color: #117281;
  align-items: center;
  padding: 0px 12px;
  position: fixed;
  width: 100%;
  top: 0px;
  left: 0px;
  box-sizing: border-box;
  z-index: 9;

  .header-search {
    flex: 1;
    height: 46px;
  }

  .header-right {
    color: #fff
  }

}

.sub-card {
  padding: 0.2rem;
  background-color: #fff;
  margin-bottom: 0.2rem;
  width: 100%;

  .sub-info {
    padding: 0.2rem;
    display: flex;

    p {
      flex: 1 1 50%
    }
  }

  .sub-name {
    padding: 0rem 0.2rem 0.2rem 0.2rem;
    color: var(--base-green);
  }
}
</style>
